import React, { ReactNode } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  title: string;
  data?: string | number | undefined | null;
  className?: string;
  titleClassName?: string;
  dataClassName?: string;
  children?: ReactNode;
}

export default class OrderBlockItem extends React.Component<IProps, {}> {
  render() {
    if (!this.props.data && !this.props.children) return null;
    return (
      <li className={`order-block-item ${this.props.className || ''}`}>
        <h3 className={`family-medium text-size-18 color-dark mr-4 ${this.props.titleClassName || ''}`}>{localeStore.t(this.props.title)}</h3>
        {this.props.data ? (
          <p className={`family-semibold text-size-18 color-dark ${this.props.dataClassName || ''}`}>{this.props.data}</p>
        ) : (
          this.props.children
        )}
      </li>
    );
  }
}
